// src/pages/Profile.js

import React, { useState, useEffect } from 'react'
import {
  Container,
  Typography,
  Grid,
  Paper,
  CircularProgress,
  Snackbar,
  Alert
} from '@mui/material'
import { useAuth } from '../contexts/AuthContext'
import { db } from '../firebase'
import { doc, getDoc } from 'firebase/firestore'
import { useNavigate } from 'react-router-dom'
import AvatarSection from '../components/Profile/AvatarSection'
import ProfileForm from '../components/Profile/ProfileForm'
import PasswordUpdateForm from '../components/Profile/PasswordUpdateForm'

// Çoklu dil desteği
import { useTranslation } from 'react-i18next'

export default function Profile() {
  const { currentUser } = useAuth()
  const navigate = useNavigate()

  const { t } = useTranslation() // <--- i18n Hook

  const [userData, setUserData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')

  useEffect(() => {
    const fetchUserData = async () => {
      if (!currentUser) return
      try {
        const userDoc = doc(db, 'users', currentUser.uid)
        const docSnap = await getDoc(userDoc)
        if (docSnap.exists()) {
          setUserData(docSnap.data())
        } else {
          setError(t('profile.userDataNotFound'))
        }
      } catch (err) {
        console.error('Kullanıcı verisi alınırken hata:', err)
        setError(t('profile.userDataFetchError'))
      } finally {
        setLoading(false)
      }
    }

    fetchUserData()
  }, [currentUser, t])

  /**
   * Form güncellendikten sonra, /user/unanswered sayfasına yönlendiren callback
   */
  const handleProfileSave = () => {
    navigate('/ProjectsPage')
  }

  const handleCloseSnackbar = () => {
    setError('')
    setSuccess('')
  }

  if (loading) {
    return (
      <Container sx={{ mt: 4, textAlign: 'center' }}>
        <CircularProgress />
        <Typography variant="h6" sx={{ mt: 2 }}>
          {t('profile.loading')}
        </Typography>
      </Container>
    )
  }

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Grid container spacing={4}>
        {/* Avatar Bölümü */}
        <Grid item xs={12} md={4}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
            {t('profile.avatarSection')}
          </Typography>
          <AvatarSection
            userData={userData}
            setUserData={setUserData}
            setError={setError}
            setSuccess={setSuccess}
          />
        </Grid>

        {/* Profil Bilgileri ve Şifre Güncelleme */}
        <Grid item xs={12} md={8}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
            {t('profile.profileAndPassword')}
          </Typography>

          <Paper elevation={6} sx={{ padding: 4, borderRadius: 2, mb: 4 }}>
            <ProfileForm
              userData={userData}
              setError={setError}
              setSuccess={setSuccess}
              onProfileSave={handleProfileSave}
            />
          </Paper>
          <Paper elevation={6} sx={{ padding: 4, borderRadius: 2 }}>
            <PasswordUpdateForm
              setError={setError}
              setSuccess={setSuccess}
            />
          </Paper>
        </Grid>
      </Grid>

      {/* Snackbar Bildirimleri */}
      <Snackbar
        open={!!error || !!success}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        {error ? (
          <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
            {error}
          </Alert>
        ) : (
          <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: '100%' }}>
            {success}
          </Alert>
        )}
      </Snackbar>
    </Container>
  )
}